module.exports = __webpack_public_path__ + "static/img/traning2.fdf7c558.png";